import pino from 'pino';

const logger = pino({
  level: process.env.LOG_LEVEL || `info`,
  redact: {
    paths: [
      `req.headers.Authorization`,
      `req.headers.authorization`,
      `req.headers.cookie`,
      `req.headers.Authorization`,
      `jwt.accessToken`,
    ],
    censor: `[REDACTED]`,
    remove: true,
  },
});

export default logger;
